export const formatPrice = (price, country = 'da-DK') => {
    return new Intl.NumberFormat(country, {
        style: 'decimal',
        minimumFractionDigits: 2, // Ensures two decimal places
        maximumFractionDigits: 2
    }).format(price);
};

export const parseFormattedPrice = (priceStr: string, country = 'da-DK'): number | undefined => {
    const formatter = new Intl.NumberFormat(country);
    const parts = formatter.formatToParts(1234.5);

    const groupPart = parts.find(part => part.type === 'group');
    const decimalPart = parts.find(part => part.type === 'decimal');

    // Use optional chaining with default values for safety
    const groupSeparator = groupPart?.value || '';
    const decimalSeparator = decimalPart?.value || '.';

    // Remove group separators and replace the decimal separator
    const normalizedPriceStr = priceStr.replaceAll(groupSeparator, '').replace(decimalSeparator, '.');

    // Convert the normalized string to a float
    const parsedPrice = parseFloat(normalizedPriceStr);
    return isNaN(parsedPrice) ? undefined : parsedPrice;
};